var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 15394",
    transform: "translate(-949 -88)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#fff",
    "data-name": "Ellipse 1638",
    transform: "translate(949 88)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 15195"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 15196"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a3b5c9",
    d: "M973.018 113.097a6.1 6.1 0 1 0-6.1-6.1 6.09 6.09 0 0 0 6.1 6.1m0-10.053a3.892 3.892 0 1 1-3.892 3.892 3.9 3.9 0 0 1 3.892-3.892m-5.124 13.62a11.07 11.07 0 0 0-4.8 4.8 1.14 1.14 0 0 0 .454 1.492 2.4 2.4 0 0 0 .584.13 1.07 1.07 0 0 0 .973-.584 8.73 8.73 0 0 1 3.827-3.827 8.9 8.9 0 0 1 6.81-.584 8.73 8.73 0 0 1 5.189 4.41 1.103 1.103 0 0 0 1.946-1.038 11.155 11.155 0 0 0-14.982-4.8",
    "data-name": "Pfad 8724"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profil.29d2559de3081c95446b153fe01d670a.svg";